import type { IGatsbyImageData } from 'gatsby-plugin-image';

import { generateClassName } from '@klv/shared/utils/functions';
import Image from '@klv/atoms/image';

import * as styles from './styles/featureCard.module.scss';
import type { IFeatureCard } from './types';

const FeatureCard = ({
  className = '',
  image,
  headline,
  subhead,
}: IFeatureCard) =>  (
  <div className={generateClassName([styles.featureCard, className])} tabIndex={0} data-feature-card>
    <div className={styles.imageContainer}>
      <Image className={styles.image} imageData={image?.gatsbyImage as IGatsbyImageData} altText={image?.altText}/>
    </div>
    <div className={styles.textContainer}>
      <h3 className={generateClassName([styles.text, styles.headline])}>
        {headline}
      </h3>
      <p className={styles.text}>
        {subhead}
      </p>
    </div>
  </div>
);

export default FeatureCard;
